import React from 'react';
import UserAdsListing from '../AddUserListing/UserAdsListing';

export default function Myvehicles() {
  return <UserAdsListing />;
}
